var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Vlt-spinner",class:{
    'Vlt-spinner--small': _vm.small,
    'Vlt-spinner--smaller': _vm.smaller,
    'Vlt-spinner--white': _vm.white,
  }})
}
var staticRenderFns = []

export { render, staticRenderFns }